import React from "react";
import { Card, Link, makeStyles, Typography } from "@material-ui/core";
import { CheckCircle as CheckCircleIcon } from "@material-ui/icons";
import { borderRadiusValue, graphicsDarkRed } from "../../lib/constants";
import MobileDialog from "../MobileDialog";

const useStyles = makeStyles(
  () => ({
    root: {
      alignItems: "center",
      backgroundColor: "#ffffff",
      borderRadius: borderRadiusValue,
      boxShadow: "0 1.5px 12px 2px rgb(0 0 0 / 6%)",
      //boxShadow: "rgb(213, 213, 213) 5px 5px 9px, rgb(255, 255, 255) -5px -5px 9px",
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      flexShrink: 0,
      height: "65px",
      //margin: "10px 10px 0px 10px",
      overflow: "scroll",
      padding: "16px"
    },
    selectedIcon: {
      color: graphicsDarkRed + "70",
      display: "flex",
      marginRight: "16px"
    },
    textContainer: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 0,
      flexShrink: 1,
      width: "calc(100% - (16px + 24px))",
      height: "65px"
    },
    heading: {
      color: "#666",
      display: "flex",
      fontWeight: 500,
      userSelect: "none",
      width: "100%"
    },
    text: {
      display: "flex",
      userSelect: "none",
      maskImage: "linear-gradient(to bottom, black 50%, transparent 100%)",
      overflow: "hidden",
      textOverflow: "ellipsis",
      height: "81px"
      //whiteSpace: "nowrap"
    }
  }),
  {
    name: "MobileSelectedTextCard"
  }
);

/**
 * @param {{ heading: string, text: string }} props
 */
export function MobileSelectedTextCard(props) {
  const { heading, text } = props;
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const toggleDialog = React.useCallback(() => setDialogOpen(!dialogOpen), [dialogOpen]);
  return (
    <>
      <MobileDialog heading={heading} onClose={toggleDialog} open={dialogOpen} text={text} />
      <Card
        style={{
          //margin: "10px 10px 65px 10px",
          borderRadius: "12px",
          boxShadow: "0 1.5px 12px 2px rgb(0 0 0 / 6%)",
          marginBottom: "10px",
          height: "64.3px" // here
        }}
        className={classes.root}
      >
        <CheckCircleIcon className={classes.selectedIcon} />
        <div className={classes.textContainer}>
          <Typography classes={{ root: classes.heading }} variant={"body1"}>
            {heading}
          </Typography>
          <Typography className={classes.text} color={"textSecondary"} variant={"body2"}>
            {text}
          </Typography>
          <Link onClick={toggleDialog} variant={"body2"}>
            Mehr anzeigen
          </Link>
        </div>
      </Card>
      {/*<div className={classes.root}>
        <CheckCircleIcon className={classes.selectedIcon} />
        <div className={classes.textContainer}>
          <Typography classes={{ root: classes.heading }} variant={"body1"}>
            {heading}
          </Typography>
          <Typography className={classes.text} color={"textSecondary"} noWrap={true} variant={"body2"}>
            {text}
          </Typography>
          <Link onClick={toggleDialog} variant={"body2"}>
            Mehr anzeigen
          </Link>
        </div>
  </div>*/}
    </>
  );
}
